import { AxiosInstance } from 'axios';
import { LocaleMessageObject } from 'vue-i18n';
import { BaseService } from 'yellowfin-ui-lib';

export class I18NService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getFile(lang: string): Promise<LocaleMessageObject> {
		return this.mapResponse(this.http.get(`/ws/i18n/file/${lang}`));
	}

}